<template>
  <div class="question-edit">
    <div id="q-readonly" class="title" v-show="!isEditMode" ref="text" v-html="$sanitize(title)"></div>
    <div id="q-editor" class="title" v-show="isEditMode" ref="editor">{{title}}</div>
    <mu-icon
      class="editIcon"
      :size="22"
      style="cursor: pointer"
      v-tooltip.bottom="'Edit'"
      v-if="!isEditMode"
      @click.native="editMode"
      value="edit"
      secondary
    ></mu-icon>
    <div class="bottom" v-if="isEditMode">
      <mu-flat-button
        @click.native="cancel"
        :label="$t('message.cancelText')"
      ></mu-flat-button>
      <mu-raised-button
        secondary
        @click.native="updateQuestion"
        :label="$t('message.saveText')"
      ></mu-raised-button>
    </div>
  </div>
</template>
<script>

  import DiscussionApi from '../../../api/Discussion'
  import Medium from 'medium.js/medium'

  export default {
    name: 'edit-question-title',
    data() {
      return {
        isSaving: false,
        isEditMode: false,
        editor: undefined
      }
    },
    props: {
      title: {
        type: String,
      },
      questionId: {
        type: Number,
        default: 0
      }
    },
    methods: {
      cancel() {
        let self = this;
        self.isEditMode = false;
      },
      editMode() {
        let self = this;
        self.isEditMode = true;
        self.editor = new Medium({
          mode: Medium.inlineMode,
          autoHR: false,
          element: document.getElementById('q-editor'),
          pasteAsText: true,
          beforeInvokeElement: function () {
            this.setClean(false);
          }
        });
        self.editor.value(self.title);
        self.$nextTick(function () {
          self.editor.focus();
          self.editor.cursor.set(self.title.length)
        })
      },
      updateQuestion() {
        let self = this;
        if (self.editor.value().trim() === '') {
          self.$toastr.error('The title cannot be empty');
          return;
        }

        if (self.editor.value().includes('&nbsp;')) {
          self.$toastr.error('The title cannot be empty or start with a space');
          return;
        }
        self.isSaving = true;
        let model = {
          question_id: self.questionId,
          question: self.editor.value()
        }
        DiscussionApi.updateQuestion(model)
          .then(function () {
            self.isSaving = false;
            self.isEditMode = false;
            self.$emit('questionUpdated', model.question);
            self.$toastr.success('Updated question');
          })
      }
    }
  }
</script>
<style lang="less">
  .question-edit {
    .title {
      margin: -8px 0 8px 0;
      font-size: 32px;
      font-weight: 500;
      color: #0179d5;
    }
    #q-readonly {
      display: inline-block;
    }
    .mu-icon {
      margin: 0 0 0 5px;
      font-size: 24px;
      color: #8CD1FF;
    }
  }
</style>



// WEBPACK FOOTER //
// EditQuestionTitle.vue?62925e5d